import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import Settings from "../../services/settings.service";
import AppleIcon from "../../assets/img/apple.png";
import GoogleIcon from "../../assets/img/google.png";
import HuaweiIcon from "../../assets/img/huawei.png";
import QRCode from "qrcode.react";
import Storage from "../../services/storage.service";
import GTMService from "../../services/gtm.service";
import ActivationSummary from '../shared/stm-activation-summary';
import FirebaseAnalytics from "../../services/analytics.service";

const subscriptions = [];
export default function AlmostDone() {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [qrValue, setQRValue] = useState();

  useEffect(() => {
    GTMService.eventOb("Almost Done", "on_load", "Almost Done", "on_load");
    setQRValue(Storage.get("user-email", true));
    let method = Storage.get("sim_option", true)
    let firebase_param = {
      activate_method: method,
      method: method,
    }
    commonRecordFirebaseEvent({interaction_type: "view" });
    FirebaseAnalytics.sim_activated(firebase_param);
    FirebaseAnalytics.delivery_qr_viewed();
  }, []);


  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  const commonRecordFirebaseEvent = ({event_label = "", interaction_type = "", ...properties }) => {
    const event_params = {
      event_category: "onboarding_qr_code",
      event_screen: "scan_activation_qr",
      event_label,
      interaction_type,
      ...properties
    }
    FirebaseAnalytics.commonFunction(event_params)
  }
  return (
    <div className="almost-done-container">
      <div className="storefront-two-col-pg">
        <div className="container-ob-single almost-done-text-container">
          <div>
            <div className="waiting_for_delivery">
              <div>
                <h1 className="mainHeading-almost-done">
                  {Translations.keys["ob_waiting_for_driver_almost_done"]}
                </h1>
                <p className="qrCodeText-almost-done">
                  {Translations.keys["ob_waiting_for_driver_qrcode_text"]}
                </p>
                <p className="qrCodeText-almost-done redColor">
                  {Translations.keys["ob_waiting_for_driver_qrcode_screenshot"]}
                </p>
              </div>
            </div>
            <div className="download-app-section-almost-done">
              <span>{translationKeys["please_download_app_and_login"]}</span>
              <ul className="modal-app-links">
                <li>
                  <a href={Settings?.ob_google_play ||""} target="_blank" rel="noopener noreferrer">
                    <img src={GoogleIcon} alt="Google" />
                  </a>
                </li>
                <li>
                  <a href={Settings?.ob_app_store || ""} target="_blank" rel="noopener noreferrer">
                    <img src={AppleIcon} alt="Apple" />
                  </a>
                </li>
                <li>
                  <a href={Settings?.ob_app_gallery || ""} target="_blank" rel="noopener noreferrer">
                    <img src={HuaweiIcon} alt="Huawei" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="qrCodeContainer">
            <div className="qrCode">
              {qrValue ? (
                <QRCode
                  value={qrValue}
                  style={{ width: "185px", height: "185px" }}
                />
              ) : (
                "Error Loading QRCode"
              )}
            </div>
          </div>
        </div>
        <div className="stm-act-summary hz-padding"><ActivationSummary /></div>
      </div>
    </div>
  );
}
